<template>
    <div>
        <img class="education-banner" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-banner.png" alt="">
        <div class="link-box" style="margin-bottom: 120px;">
            <div class="link-box-title">覆盖零售机构全部经营环节</div>
            <div class="link-box-title2">提供全方位解决方案 </div>
            <div class="link-boxCont">
                <div class="link-circularBG" style="z-index: 1;">
                    <img class="link-half-arc arc-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc.png" alt="">
                    <img class="link-half-arc arc-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc-r.png" alt="">
                    <div class="link-circular">
                        <img class="link-circularImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-hover-t1.png" alt="">
                        <div class="link-circularText">数字化</div>
                    </div>
                    <div class="link-circular-Info">
                        <div class="link-circular-InfoLink"></div>
                        <div class="link-circular-InfoNum">
                            <span>1</span>
                            <div class="link-circular-InfoNumLin"></div>
                            <div class="link-circular-InfoC">
                                <div class="link-circular-InfoC-title">数字化</div>
                                <div class="link-circular-InfoC-title2">利用数字化技术帮助客户突破传统思维，</div>
                                <div class="link-circular-InfoC-title2">构建全渠道数字化营销解决方案，帮助</div>
                                <div class="link-circular-InfoC-title2">企业把技术转化为商业成果</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="link-circularBG link-circularBG2">
                    <img class="link-half-arc arc-show" style="transform: rotate(180deg);top: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc.png" alt="">
                    <img class="link-half-arc arc-show2" style="transform: rotate(180deg);top: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc-r.png" alt="">
                    <div class="link-circular">
                        <img class="link-circularImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-hover-t2.png" alt="">
                        <div class="link-circularText">战略与咨询</div>
                    </div>
                    <div class="link-circular-Info2">
                        <div class="link-circular-InfoLink"></div>
                        <div class="link-circular-InfoNum">
                            <span>2</span>
                            <div class="link-circular-InfoNumLin"></div>
                            <div class="link-circular-InfoC">
                                <div class="link-circular-InfoC-title">战略与咨询</div>
                                <div class="link-circular-InfoC-title2">为企业提供数字化转型战略及咨询、管</div>
                                <div class="link-circular-InfoC-title2">理咨询、IT规划及流程咨询服务</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="link-circularBG link-circularBG3">
                    <img class="link-half-arc arc-show"  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc.png" alt="">
                    <img class="link-half-arc arc-show2"  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc-r.png" alt="">
                    <div class="link-circular">
                        <img class="link-circularImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-hover-t3.png" alt="">
                        <div class="link-circularText">创新</div>
                    </div>
                    <div class="link-circular-Info">
                        <div class="link-circular-InfoLink"></div>
                        <div class="link-circular-InfoNum">
                            <span>3</span>
                            <div class="link-circular-InfoNumLin"></div>
                            <div class="link-circular-InfoC">
                                <div class="link-circular-InfoC-title">创新</div>
                                <div class="link-circular-InfoC-title2">发掘价值，带来全新创想，解决客户痛</div>
                                <div class="link-circular-InfoC-title2">点；优化传统流程，提高运营效率，节</div>
                                <div class="link-circular-InfoC-title2">约成本</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="recruit-cont-box">
            <div class="recruit-cont-box-l">
                <img style="margin-right: 170px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-c-t1.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">数字化</div>
                <div class="recruit-cont-box-cbg" style="margin-top: 68px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t1.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">利用数字化技术帮助客户突破传统思维，实现新的业务模式/产品属性，打造数字化生态系</div>
                        <div class="recruit-cont-box-cbg-title2">统，实现卓越用户体验和数字化转型。</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" >
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t2.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">全渠道数字化营销解决方案，从战略、咨询、研发到运营端服务，包括活动发布、线索、积</div>
                        <div class="recruit-cont-box-cbg-title2">分、电子券、级别、忠诚度、促销规则、会员管理等业务活动，帮助客户实现精准化营销，</div>
                        <div class="recruit-cont-box-cbg-title2">从而推动业务发展。</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 100px;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t3.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">帮助企业把技术转化为商业成果，如：应用定制化开发（微生态、移动化等）、敏捷转型、</div>
                        <div class="recruit-cont-box-cbg-title2">架构设计等。</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="recruit-cont-box">
            <div class="recruit-cont-box-l">
                <img style="margin-right: 112px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-c-t2.png" alt="">
            </div>
            <div class="recruit-cont-box-r">
                <div class="recruit-cont-box-title">战略与咨询</div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 0;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;opacity: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t3.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">帮助企业塑造业务架构和管理方式，解决业务挑战</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 0;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;opacity: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t3.png" alt="">

                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">企业数字化转型战略及咨询</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 0;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;opacity: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t3.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">企业管理咨询</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 0;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;opacity: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t3.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r">
                        <div class="recruit-cont-box-cbg-title2">IT规划及流程咨询</div>
                    </div>
                </div>
                <div class="recruit-cont-box-link">
                    <div class="jump" style="top: -15px;"><div class="jumpN"></div></div>
                    <div class="jump" style="top: -5px;"><div class="jumpN"></div></div>
                    <div class="jump" style="top: 5px;"><div class="jumpN"></div></div>
                    <div class="jump" style="top: 15px;"><div class="jumpN"></div></div>
                </div>
            </div>
        </div>
        <div class="recruit-cont-box" style="margin-top: 115px;margin-bottom: 60px;">
            <div class="recruit-cont-box-l">
                <img style="margin-right: 98px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-c-t3.png" alt="">
            </div>
            <div class="recruit-cont-box-r" style="position:relative;left: -58px;">
                <div class="recruit-cont-box-title">创新</div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 0;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;opacity: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t3.png" alt="">
                    </div>
                    <div class="recruit-cont-box-cbg-r" style="width: 450px;">
                        <div class="recruit-cont-box-cbg-title2">根据独特的洞察，发掘价值，带来全新创想，解决客户痛点</div>
                    </div>
                </div>
                <div class="recruit-cont-box-cbg" style="margin-bottom: 0;">
                    <div class="recruit-cont-box-cbg-l">
                        <img style="margin-right: 38px;opacity: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/r-num-t3.png" alt="">

                    </div>
                    <div class="recruit-cont-box-cbg-r" style="width: 450px;">
                        <div class="recruit-cont-box-cbg-title2">优化传统流程，提高运营效率，节约成本，从而给企业带来卓越业绩</div>
                    </div>
                </div>
                <div class="recruit-cont-box-link" style="height: 44px;">
                    <div class="jump" style="top: -15px;"><div class="jumpN"></div></div>
                    <div class="jump" style="top: 5px;"><div class="jumpN"></div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "education",
        mounted() {

        }
    }
</script>

<style lang="less" scoped>
    .education-banner{
        width: 100%;
        margin-top: 7px;
    }

    .link-box{
        width: 100%;
        height: 895px;
        background: #f8faff;
        box-sizing: border-box;
        padding-top: 60px;
        .link-box-title{
            font-size: 32px;
            font-weight: bold;
            color: #000;
            text-align: center;
        }
        .link-box-title2{
            font-size: 32px;
            color: #000;
            text-align: center;
            margin-top: 20px;
            margin-bottom: 150px;
        }
        .link-boxCont{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            .link-circularBG{
                cursor: pointer;
                width: 400px;
                height: 400px;
                -webkit-border-radius: 100%;
                -moz-border-radius: 100%;
                border-radius: 100%;
                /*border: 5px solid #DC0616;*/
                /*border: 5px solid #E5EEFF;*/
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                .link-half-arc{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                }
                .arc-show{
                    display: block;
                }

                .arc-show2{
                    display: none;
                }
                .link-circular{
                    width: 273px;
                    height: 273px;
                    background: #E4ECFF;
                    -webkit-border-radius: 100%;
                    -moz-border-radius: 100%;
                    border-radius: 100%;
                    position: relative;
                    z-index: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .link-circularImg{
                        width: 140px;
                        margin-bottom: 24px;
                    }
                    .link-circularText{
                        font-size: 18px;
                        font-weight: bold;
                        color: #586480;
                    }
                }
                .link-circular-Info{
                    position: absolute;
                    bottom: -88px;
                    display: none;
                    .link-circular-InfoLink{
                        width: 2px;
                        height: 51px;
                        background: #DC0616;
                    }
                    .link-circular-InfoNum{
                        width: 37px;
                        height: 37px;
                        background: #DC0616;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 28px;
                        color: #FFFFFF;
                        position: relative;
                        .link-circular-InfoNumLin{
                            width: 40px;
                            height: 2px;
                            background: #DC0616;
                            position: absolute;
                            right: -38px;
                            bottom: 10px;
                        }
                        .link-circular-InfoC{
                            position: absolute;
                            right: -348px;
                            top: 5px;
                            width: 300px;
                            .link-circular-InfoC-title{
                                font-size: 28px;
                                color: #DC0616;
                                margin-bottom: 10px;
                            }
                            .link-circular-InfoC-title2{
                                font-size: 16px;
                                color: #000;
                            }
                        }
                    }
                }
                .link-circular-Info2{
                    position: absolute;
                    top: -88px;
                    display: none;
                    .link-circular-InfoLink{
                        width: 2px;
                        height: 88px;
                        background: #DC0616;
                    }
                    .link-circular-InfoNum{
                        width: 37px;
                        height: 37px;
                        background: #DC0616;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 28px;
                        color: #FFFFFF;
                        position: absolute;
                        top: 0;
                        .link-circular-InfoNumLin{
                            width: 40px;
                            height: 2px;
                            background: #DC0616;
                            position: absolute;
                            right: -38px;
                            bottom: 10px;
                        }
                        .link-circular-InfoC{
                            position: absolute;
                            right: -348px;
                            top: 5px;
                            width: 300px;
                            .link-circular-InfoC-title{
                                font-size: 28px;
                                color: #DC0616;
                                margin-bottom: 10px;
                            }
                            .link-circular-InfoC-title2{
                                font-size: 16px;
                                color: #000;
                            }
                        }
                    }
                }
            }
            .link-circularBG2{
                position: relative;
                left: -3px;
            }
            .link-circularBG3{
                position: relative;
                left: -6px;
            }
            .link-circularBG:hover .link-circular-Info{
                /*border: 5px solid #DC0616;*/
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .link-circularBG:hover .link-circular-Info2{
                /*border: 5px solid #DC0616;*/
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .link-circularBG:hover .link-circular{
                background: rgba(220,6,22,.1);
            }
            .link-circularBG:hover .link-circularText{
                color: #DC0616;
            }
            .link-circularBG:hover .arc-show{
                display: none;
                z-index: 1;
            }
            .link-circularBG:hover .arc-show2{
                display: block;
                z-index: 1;
            }
        }

    }
    .recruit-cont-box{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .recruit-cont-box-title{
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .recruit-cont-box-title2{
            font-size: 20px;
            font-weight: 300;
        }
        .recruit-cont-box-cbg{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 50px;
            .recruit-cont-box-cbg-title{
                font-size: 20px;
                margin-bottom: 13px;
            }
            .recruit-cont-box-cbg-title2{
                color: #636363;
                font-size: 14px;
            }
            .recruit-cont-box-cbg-r{
                width: 560px;
            }
        }
        .recruit-cont-box-dp{
            display: flex;
            align-items: flex-start;
            .recruit-cont-box-cbg-l{
                display: flex;
                align-items: flex-start;
            }
        }
        .recruit-cont-box-dp2{
            display: flex;
            align-items: flex-start;
            .recruit-cont-box-cbg-l{
                display: flex;
                align-items: flex-start;
            }
        }
        .recruit-cont-box-r{
            position: relative;
            .recruit-cont-box-link{
                position: absolute;
                top: 92px;
                left: 30px;
                width: 2px;
                height: 130px;
                background: rgba(49, 49, 49, .33);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                .jump{
                    cursor: pointer;
                    position: relative;
                    z-index: 999;
                    width: 15px;
                    height: 15px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background:rgba(220,6,22,.17);
                    border-radius:50%;
                    .jumpN{
                        width:7px;
                        height:7px;
                        background:rgba(220,6,22,1);
                        /*background: #D2D2D2;*/
                        border-radius:50%;
                    }
                }
                .jump:hover{
                    /*background:rgba(220,6,22,.17);*/
                }
                .jump:hover .jumpN{
                    /*background:rgba(220,6,22,1);*/
                }
            }
        }
    }
</style>